const taxRateValues = [
  {
    id: '0_15',
    value: '0-15%',
  },
  {
    id: '16_25',
    value: '16-25%',
  },
  {
    id: '26_30',
    value: '26-30%',
  },
  {
    id: '31_35',
    value: '31-35%',
  },
  {
    id: 'over_35',
    value: 'Over 35%',
  }];

const expensesValues = [
  {
    id: '50_000_and_under',
    value: '$50,000 and under',
  },
  {
    id: '50_001-100_000',
    value: '$50,001 - $100,000',
  },
  {
    id: '100_001-250_000',
    value: '$100,001 - $250,000',
  },
  {
    id: '250_001-500_000',
    value: '$250,001 - $500,000',
  },
  {
    id: 'over_500_000',
    value: 'Over $500,000',
  }];

const specialExpensesValues = [
  {
    id: 'none',
    value: 'None',
  },
  {
    id: '50_000_and_under',
    value: '$50,000 and under',
  },
  {
    id: '50_001-100_000',
    value: '$50,001 - $100,000',
  },
  {
    id: '100_001-250_000',
    value: '$100,001 - $250,000',
  },
  {
    id: '250_001-500_000',
    value: '$250,001 - $500,000',
  },
  {
    id: 'over_500_000',
    value: 'Over $500,000',
  }];

const timeFrameForSpecialExpensesValues = [
  {
    id: 'within_2_years',
    value: 'Within 2 years',
  },
  {
    id: '3_5_years',
    value: '3-5 years',
  },
  {
    id: '6_10_years',
    value: '6-10 years',
  }];

const liquidityNeedsValues = [
  {
    id: 'very_important',
    value: 'Very Important',
    subText: 'The ability to quickly and easily convert to cash all or a portion of the investments in under 5 years in this account is very important.',
  },
  {
    id: 'somewhat_important',
    value: 'Somewhat Important',
    subText: 'The ability to quickly and easily convert to cash all or a portion of the investments in this account in over 5 years is somewhat important.',
  },
  {
    id: 'does_not_matter',
    value: 'Does not matter',
    subText: 'The ability to quickly and easily convert to cash all or a portion of the investments in this account is not important.',
  }];

const riskToleranceValues = [
  {
    id: 'conservative',
    value: 'Conservative',
    subText: 'I want to preserve my initial principal in this account, with minimal risk, even if that means this account does not generate significant income or returns and may not keep pace with inflation.',
  },
  {
    id: 'moderately_conservative',
    value: 'Moderately Conservative',
    subText: 'I am willing to accept a low risk to my initial principal, including low volatility, to seek a modest level of portfolio returns.',
  },
  {
    id: 'moderate',
    value: 'Moderate',
    subText: 'I am willing to accept some risk to my initial principal and tolerate some volatility to seek higher returns and understand I could lose a portion of the money invested.',
  },
  {
    id: 'moderately_aggressive',
    value: 'Moderately Aggressive',
    subText: 'I am willing to accept a high risk to my initial principal, including high volatility, to seek high returns over time, and understand I could lose a substantial amount of the money invested.',
  },
  {
    id: 'significant_risk',
    value: 'Significant Risk',
    subText: 'I am willing to accept the maximum risk to my initial principal to aggressively seek maximum returns and understand I could lose most, or all, of the money invested.',
  }];

const investmentObjectivesValues = [
  {
    id: 'capital_preservation',
    value: 'Capital Preservation',
    subText: 'Preservation of capital with a primary consideration on income.',
  },
  {
    id: 'income',
    value: 'Income',
    subText: 'A balance between capital appreciation and income with a primary consideration being income.',
  },
  {
    id: 'growth',
    value: 'Growth',
    subText: 'Capital appreciation through quality equity investment and little or no income.',
  },
  {
    id: 'maximum_growth',
    value: 'Maximum Growth',
    subText: 'Maximum capital appreciation with higher risk and little to no income.',
  },
  {
    id: 'speculation',
    value: 'Speculation',
    subText: 'Maximum total return potential, involving a higher degree of risk through investment in a broad spectrum of securities.',
  }];

const investmentPortfolioValues = [{
  id: 'less_than_1_3',
  value: 'Less than 1/3 of my financial portfolio',
},
{
  id: '1_3-2_3',
  value: 'Roughly 1/3 to 2/3 of my financial portfolio',
},
{
  id: 'more_than_2_3',
  value: 'More than 2/3 of my financial portfolio',
}];

const timeHorizonValues = [
  {
    id: 'short',
    value: 'Short',
    subText: 'I plan on keeping this account open and investing for less than 4 years to achieve my financial goals.',
  },
  {
    id: 'average',
    value: 'Average',
    subText: 'I plan on keeping this account open and investing for more than 5 years, but less than 7 years to achieve my financial goals.',
  },
  {
    id: 'longest',
    value: 'Longest',
    subText: 'I plan on keeping this account open and investing for more than 8+ years to achieve my financial goals.',
  }];

const individualStocksYearOfExperienceValues = [
  {
    id: '0',
    value: '0',
  },
  {
    id: '1-5',
    value: '1-5',
  },
  {
    id: 'over_5',
    value: 'Over 5',
  },
];

const transactionNumberPerYearValues = [
  {
    id: '0_5',
    value: '0-5',
  },
  {
    id: '6_15',
    value: '6-15',
  },
  {
    id: 'over_15',
    value: 'Over 15',
  },
];

const decisionMakingValues = [
  {
    id: 'consulting',
    value: 'I consult with my broker, investment adviser, CPA, or other financial professional.',
  },
  {
    id: 'own_decisions',
    value: 'I generally make my own decisions and/or consult with my co-applicant(s).',
  },
  {
    id: 'family_decisions',
    value: 'I discuss investment decisions with family and/or friends.',
  },
];

const fundingMethodsValues = [
  {
    id: 'income',
    value: 'Income',
  },
  {
    id: 'pension_or_retirement_savings',
    value: 'Pension or retirement savings',
  },
  {
    id: 'funds_from_other_account',
    value: 'Funds from another account',
  },
  {
    id: 'gift',
    value: 'Gift',
  },
  {
    id: 'sale',
    value: 'Sale of business or property',
  },
  {
    id: 'insurance_payout',
    value: 'Insurance Payout',
  },
  {
    id: 'inheritance',
    value: 'Inheritance',
  },
  {
    id: 'social_security_benefits',
    value: 'Social Security benefits',
  },
  {
    id: 'home_equity',
    value: 'Home Equity Line of Credit/Reverse Mortgage',
  },
];

const investmentExperienceDisplayableValues = [
  { id: 'mutualFunds', label: 'Mutual Funds/ETFs' },
  { id: 'commodities', label: 'Commodities' },
  { id: 'individualStocks', label: 'Stocks' },
  { id: 'bonds', label: 'Bonds' },
  { id: 'options', label: 'Options' },
  { id: 'securitiesFutures', label: 'Securities Futures' },
  { id: 'annuities', label: 'Annuities' },
  { id: 'alternatives', label: 'Alternative (structured products, hedge funds, etc.)' },
  { id: 'margin', label: 'Margin' },
  { id: 'REITs', label: 'REITs' },
];

export default {
  taxRateValues,
  expensesValues,
  specialExpensesValues,
  timeFrameForSpecialExpensesValues,
  liquidityNeedsValues,
  riskToleranceValues,
  investmentObjectivesValues,
  investmentPortfolioValues,
  timeHorizonValues,
  individualStocksYearOfExperienceValues,
  transactionNumberPerYearValues,
  decisionMakingValues,
  fundingMethodsValues,
  investmentExperienceDisplayableValues,
};



// WEBPACK FOOTER //
// ./src/components/SolicitedUsers/helper.js